<!-- Nameplate Change Modal -->
<div class="modal fade" id="nameplateChangeModal" tabindex="-1" aria-labelledby="nameplateChangeModalLabel"
    aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
        <div class="modal-content bg-dark text-white border-secondary shadow-lg">
            <div class="modal-header border-secondary">
                <h5 class="modal-title fw-bold text-white d-flex align-items-center gap-2"
                    id="nameplateChangeModalLabel">
                    <i class="bi bi-card-image text-danger fs-4"></i>
                    Change Nameplate
                </h5>
                <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"
                    aria-label="Close"></button>
            </div>
            <div class="modal-body p-4">
                <!-- Live Preview Card (Matching Lobby Player List Component Size) -->
                <div class="mb-4 text-center">
                    <h6 class="text-uppercase small fw-bold text-secondary mb-2">Live Preview</h6>
                    <div class="p-2 rounded friend-item d-flex align-items-center position-relative overflow-hidden border border-secondary shadow mx-auto"
                        [style]="selectedNameplate()?.nameplate?.backgroundUrl"
                        style="background-size: cover; background-position: center; max-width: 320px;">
                        
                        <div class="position-relative me-3 flex-shrink-0">
                            <img [src]="currentUser().avatar"
                                class="rounded-circle" width="40" height="40" style="object-fit: cover;" alt="avatar">
                            <span class="position-absolute bottom-0 end-0 p-1 rounded-circle bg-success border border-dark" style="width: 10px; height: 10px;"></span>
                        </div>

                        <div class="flex-grow-1 text-truncate text-start">
                            <div class="fw-bold d-flex align-items-center gap-1 text-white" style="text-shadow: 0 1px 2px rgba(0,0,0,0.9);">
                                <span>{{ currentUser().name }}</span>
                            </div>
                            <small class="d-flex align-items-center gap-1 text-truncate text-white opacity-75" style="font-size: 0.8rem; text-shadow: 0 1px 2px rgba(0,0,0,0.9);">
                                <span>{{ selectedNameplate()?.nameplate?.description || 'Default Nameplate' }}</span>
                            </small>
                        </div>
                    </div>
                </div>

                <!-- Nameplate Grid -->
                <div class="nameplate-grid mb-0 overflow-y-auto overflow-x-hidden px-1 border border-dark rounded"
                    style="max-height: 380px; background-color: rgba(0,0,0,0.2); border-color: #1a1a1a !important;">
                    <div class="row g-3 p-3">
                        @for(np of nameplates(); track $index) {
                        <div class="col-12 col-md-6">
                            <div class="nameplate-card p-3 rounded cursor-pointer position-relative border transition-all"
                                [class.border-danger]="np.active" [class.border-secondary]="!np.active"
                                [class.border-3]="np.active" (click)="selectNameplate(np)"
                                style="background-color: #141418;">
                                <div class="profile-nameplate p-3 rounded mb-2 overflow-hidden border border-dark"
                                    [style]="np.nameplate.backgroundUrl"
                                    style="background-size: cover; background-position: center; height: 60px;">
                                    <div class="fw-bold text-white small px-2 py-1 rounded d-inline-block bg-dark bg-opacity-75"
                                        style="text-shadow: 0 1px 2px rgba(0,0,0,0.9);">
                                        {{ np.nameplate.description }}
                                    </div>
                                </div>
                                <div class="d-flex align-items-center justify-content-between">
                                    <small class="text-muted text-truncate me-2" style="font-size: 0.78rem;">{{
                                        np.description }}</small>
                                    @if(np.active) {
                                    <span class="badge bg-success flex-shrink-0">Equipped</span>
                                    }
                                </div>
                            </div>
                        </div>
                        }
                    </div>
                </div>
            </div>
            <div class="modal-footer p-0 border-0 gap-0">
                <button type="button" class="btn btn-dark w-50 m-0 rounded-0 rounded-bottom-start fw-bold"
                    style="height: 4rem;" data-bs-dismiss="modal">Cancel</button>
                <button type="button" class="btn btn-danger w-50 m-0 rounded-0 rounded-bottom-end fw-bold"
                    style="height: 4rem;" (click)="saveNameplate()" data-bs-dismiss="modal">Equip Nameplate</button>
            </div>
        </div>
    </div>
</div>